import application from 'application/application';

const controller = 'DefaultInitialController';

application

	.controller(controller, ['$scope', '$timeout', 'API', 'helper', ($scope, $timeout, API, helper) => {

		$scope.keywordsAPIURL = helper.http(API.userKeywords, 'GET').url;

		$scope.keywordsSelectHook = response => response.itens.map(item => ({ id: item.id, keyword: item.palavraChave }));

		$scope.genders = [
			{
				id: 1,
				label: 'Masculino'
			},
			{
				id: 2,
				label: 'Feminino'
			},
			{
				id: 3,
				label: 'Outro'
			}
		];

		$timeout(() => {

			$scope.genders.push({
				id: 4,
				label: 'Unicórnio'
			});

			$scope.$apply();

		}, 3000);

		$scope.selectedUF = 20068;

		$scope.selectedCity = 31212;

		$scope.uf = helper.http(API.federativeUnits, 'GET').url;

		$scope.cities = helper.http(API.cities, 'GET').url;

		$scope.clients = helper.http(API.customers, 'GET').url;

		$scope.uclients = helper.http(API.usersCustomers, 'GET').url;

		// $scope.aaa = 20296;

	}]);

export default controller;
